import { Component, OnInit } from '@angular/core';
import { NbButtonModule, NbCardModule, NbDialogRef, NbIconModule } from '@nebular/theme';
import { UtilityService } from 'src/app/core/services/utility.service';
import { SourceItem } from 'src/app/models/drb-models/source-item';
import { DRB_ID_TYPE } from 'src/app/shared/constants/general-constants';

@Component({
  selector: 'app-view-source-item',
  templateUrl: './view-source-item.component.html',
  styleUrls: ['./view-source-item.component.css'],
  imports: [NbCardModule, NbIconModule, NbButtonModule]
})
export class ViewSourceItemComponent implements OnInit {
  public sourceItem: SourceItem;
  public type;
  public title;

  constructor(
    protected ref: NbDialogRef<ViewSourceItemComponent>,
    public utility: UtilityService
  ) {}

  public ngOnInit() {
    if (this.type === DRB_ID_TYPE.FILE) {
      this.title = $localize`Viewing File Source`;
    }
    if (this.type === DRB_ID_TYPE.LINK) {
      this.title = $localize`Viewing Link Source`;
    }
    if (this.type === DRB_ID_TYPE.VIDEO) {
      this.title = $localize`Viewing Video Source`;
    }
  }

  public close() {
    this.ref.close();
  }

  public titleCaseWord(word: string) {
    if (!word) {
      return word;
    }

    return word[0].toUpperCase() + word.substring(1).toLowerCase();
  }
}
